require('hasta-la-vista-ui-core/dist/hasta-la-vista-ui-core.min.css')
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'url-polyfill';
import 'mdn-polyfills/Object.assign';
import 'mdn-polyfills/Array.prototype.find';
import 'mdn-polyfills/Array.prototype.includes';
import 'mdn-polyfills/Array.prototype.findIndex';
import 'mdn-polyfills/Array.from';
import 'mdn-polyfills/String.prototype.includes';
import 'mdn-polyfills/String.prototype.startsWith';
import 'mdn-polyfills/Element.prototype.closest';
import values from 'object.values'

// node.prepend polyfill
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('prepend')) {
            return;
        }
        Object.defineProperty(item, 'prepend', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function prepend() {
                var argArr = Array.prototype.slice.call(arguments),
                    docFrag = document.createDocumentFragment();

                argArr.forEach(function (argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });

                this.insertBefore(docFrag, this.firstChild);
            }
        });
    });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

if (!Object.values) values.shim();

import Promise from 'promise-polyfill'
if (!window.Promise) window.Promise = Promise

require('smoothscroll-polyfill').polyfill();

import Vue from 'vue'
import App from './app.vue'
import router from './router'
import VueHead from 'vue-head'
import Components from '@/components'
import SKCoreUi, {Utils, Toaster} from 'hasta-la-vista-ui-core'
import http from 'hasta-la-vista-middleware-api/http'

Vue.config.productionTip = false

// Configure middleware
http.defaults.baseURL = process.env.API
http.defaults.baseLinkURL = process.env.APILINK

// Configure hasta-la-vista-ui-core
Utils.GoogleMapsApiConfig.api_key = process.env.GOOGLE_MAPS_API_KEY
Utils.GoogleMapsApiConfig.libraries = ['places']
Vue.use(VueHead)
Vue.use(SKCoreUi)
let componentPrefix = 'Sk';

Object.keys(Components).forEach(key => {
    Vue.component(`${componentPrefix}${key}`, Components[key])
})

// detect no-cache or resync or preview querieStrings and persist them throughout the site
router.beforeEach((to, from, next)=> {
    if (from.query.noCache && !to.query.noCache)
        next({path: to.path, query: {noCache: from.query.noCache}})

    next();
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<app></app>',
    components: {App},
    mounted() {
        document.dispatchEvent(new Event('app.rendered'));
    }

}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js